import React, {
  useMemo,
  MouseEvent,
} from 'react';
import clsx from 'clsx';
import IconButton from '@mui/material/IconButton';
import Spinner from 'pages/Dashboard/components/Spinner';
import ToolTip from 'core/components/Tooltip';
import UrgentIcon from 'core/icons/urgent';
import {
  useUpdateToDoHandler,
} from 'pages/Dashboard/pages/Todos/hooks';

type Parts = 'icon' | 'root';

type Props = {
  toDoId?: number;
  isUrgent?: boolean;
  dueDate?: string | null;
  isAbandoned?: boolean;
  className?: string;
  classes?: Partial<Record<Parts, string>>;
};

export default function Urgent({
  toDoId = 0,
  className,
  isUrgent = false,
  dueDate,
  isAbandoned = false,
  classes = {},
}: Props) {
  const urgent = useMemo(() => (
    isUrgent
      ? { text: 'Urgent', color: '!text-red-600' }
      : { text: 'Not Urgent', color: '!text-gray-400' }
  ), [isUrgent]);

  const {
    asyncHandler: updateToDo,
    isLoading: isUpdating,
  } = useUpdateToDoHandler({});

  const handleToggle = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    updateToDo({ toDoId, isUrgent: !isUrgent, dueDate: dueDate ?? null });
  };

  return (
    <ToolTip
      title={isAbandoned ? urgent.text : 'Toggle Urgent'}
      aria-label={isAbandoned ? urgent.text : 'Toggle Urgent'}
    >
      <div className={clsx('relative', className, classes.root)}>
        <IconButton
          disabled={isAbandoned}
          size="small"
          color="error"
          onClick={handleToggle}
        >
          {isUpdating
            ? <Spinner />
            : (
              <UrgentIcon
                className={clsx('!h-5 !w-5 ml-1 mt-1 cursor-pointer', urgent.color, classes.icon)}
              />
            )}
        </IconButton>
      </div>
    </ToolTip>
  );
}
